<div class="row">
  <div tabindex="0" class="col-12 text-center" [ngStyle]="{ color: text_color }" [innerHTML]="getHtml(component.primary.hero_subtitle, vehicle)"></div>
</div>
